export default __webpack_public_path__ + "static/media/soya.a70bb828.svg";